export default __webpack_public_path__ + "static/ogp_reimu-1.0.0.png";